<template>
    <div class="modal" id="urlDisplayModal" tabindex="-1" role="dialog" aria-labelledby="urlDisplayModalLabel">
        <div class="modal-content">
            <div class="subject">{{subject}}</div>
            <div class="content">
                <p v-for="url in urls">{{url}}</p>
            </div>
            <div class="actions">
                <button class="btn close-button" @click="hideModal">Close</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "url-display-modal",
        data() {
            return {
                subject: null,
                urls: null
            }
        },
        methods: {
            showModal(subject, urls) {
                this.subject = subject;
                this.urls = urls;
                $('#urlDisplayModal').modal('show');
            },
            hideModal() {
                $('#urlDisplayModal').modal('hide');
            }
        },
        mounted() {
            $('#urlDisplayModal').modal({show: false});
        }
    }
</script>

<style scoped>

    .close-button {
        width: 125px;
        height: 40px;
        background-color: rgba(255, 0, 67, 1);
        color: white;
        font-family : 'Digital-Serial-Bold';
        position: absolute;
        right: 20px;
        bottom: 0;
        top: 0;
        margin: auto;
        font-size: 14px;
        border: none;
    }

    .actions {
        width: 100%;
        height: 50px;
        background-color: rgb(17,21,26);
        color: white;
        font-family : 'Digital-Serial-Bold';
        line-height: 50px;
        font-size: 24px;
        padding-left: 20px;
        position: absolute;
        bottom: 0;
        left: 0;
    }

    .subject {
        width: 100%;
        height: 50px;
        background-color: rgb(17,21,26);
        color: white;
        font-family : 'Digital-Serial-Bold';
        line-height: 50px;
        font-size: 24px;
        padding-left: 20px;
    }

    .content {
        width: 100%;
        height: 100%;
        overflow: auto;
        display: block;
        margin-top: 1%;
        margin-left: 1%;
    }

    .modal {
        display: none;
        /* Hidden by default */
        position: fixed;
        /* Stay in place */
        /* Sit on top */
        /* Location of the box */
        left: 25%;
        top: 25%;
        width: 50%;
        /* Full width */
        height: 50%;
        /* Full height */
        overflow: hidden;
    }

    .modal-content {
        margin: auto;
        display: block;
        width: 90%;
        height: 100%;
        position: relative;

        -webkit-animation-name: zoom;
        -webkit-animation-duration: 0.6s;
        animation-name: zoom;
        animation-duration: 0.6s;
    }

    @-webkit-keyframes zoom {
        from {
            -webkit-transform: scale(0)
        }
        to {
            -webkit-transform: scale(1)
        }
    }

    @keyframes zoom {
        from {
            transform: scale(0)
        }
        to {
            transform: scale(1)
        }
    }

    @media only screen and (max-width: 700px) {
        .modal-content {
            width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/modals/UrlDisplayModal.vue